/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import FileUploaderProvider from 'DesignSystem/FileUploaderProvider/react'
import Modal from './Modal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/UploadVideo/Content",
  restrictions
  
}) {
  return (<React.Fragment
>
<FileUploaderProvider
  viewPath={`${viewPath}/FileUploaderProvider`}
 reset={true}
 restrictions={restrictions}
>
{childProps => (
<Modal
{...childProps}
  viewPath={`${viewPath}/Modal`}
/>
)}
</FileUploaderProvider>
{children}
</React.Fragment>)
}